import { ReactElement, useEffect } from 'react';
import { useBreakpoint } from 'hooks/utils/layout/useBreakpoint';
import { Breakpoints } from 'types/breakpoints';
import { useModalService } from 'hooks/useModalService';
import { ModalTarget, ModalVariant } from 'types/Modal';
import { PageSpinner } from 'components/atoms/PageSpinner';

export const PaywallPage = (): ReactElement => {
  const isDesktop = useBreakpoint(Breakpoints.DESKTOP);

  const { show: showModal, activeModal } = useModalService();

  useEffect(() => {
    const shouldShowPaywall = activeModal !== ModalVariant.SUBSCRIBE;
    if (shouldShowPaywall) {
      showModal(ModalVariant.PAYWALL, {
        target: isDesktop ? ModalTarget.PAGE_DESKTOP : ModalTarget.PAGE_MOBILE,
        onUpgradeClick: () => showModal(ModalVariant.SUBSCRIBE),
      });
    }
  }, [showModal, activeModal, isDesktop]);

  return <PageSpinner />;
};
